var deprecate = require('util-deprecate');

module.exports = deprecate(require('sprintf-js').sprintf,
  'sprintf() will be removed in the next major release, use the sprintf-js package instead.');



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/sprintf.js
// module id = 2286
// module chunks = 0